webpackJsonp([155],{

/***/ 1087:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanceEmailNotify_vue__ = __webpack_require__(2679);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6ddcc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanceEmailNotify_vue__ = __webpack_require__(4023);
function injectStyle (ssrContext) {
  __webpack_require__(4021)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a6ddcc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinanceEmailNotify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6ddcc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinanceEmailNotify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(54).f;
var create = __webpack_require__(240);
var redefineAll = __webpack_require__(247);
var ctx = __webpack_require__(64);
var anInstance = __webpack_require__(246);
var forOf = __webpack_require__(239);
var $iterDefine = __webpack_require__(150);
var step = __webpack_require__(251);
var setSpecies = __webpack_require__(252);
var DESCRIPTORS = __webpack_require__(40);
var fastKey = __webpack_require__(1353).fastKey;
var validate = __webpack_require__(1387);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var $export = __webpack_require__(28);
var meta = __webpack_require__(1353);
var fails = __webpack_require__(76);
var hide = __webpack_require__(56);
var redefineAll = __webpack_require__(247);
var forOf = __webpack_require__(239);
var anInstance = __webpack_require__(246);
var isObject = __webpack_require__(55);
var setToStringTag = __webpack_require__(105);
var dP = __webpack_require__(54).f;
var each = __webpack_require__(1422)(0);
var DESCRIPTORS = __webpack_require__(40);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(64);
var IObject = __webpack_require__(149);
var toObject = __webpack_require__(78);
var toLength = __webpack_require__(106);
var asc = __webpack_require__(1423);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1424);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(55);
var isArray = __webpack_require__(1356);
var SPECIES = __webpack_require__(22)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(146);
var from = __webpack_require__(1426);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(239);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(28);
var aFunction = __webpack_require__(80);
var ctx = __webpack_require__(64);
var forOf = __webpack_require__(239);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1450), __esModule: true };

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(241);
__webpack_require__(143);
__webpack_require__(234);
__webpack_require__(1451);
__webpack_require__(1452);
__webpack_require__(1453);
__webpack_require__(1454);
module.exports = __webpack_require__(12).Set;


/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1420);
var validate = __webpack_require__(1387);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(1421)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(28);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1425)('Set') });


/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(1427)('Set');


/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(1428)('Set');


/***/ }),

/***/ 2679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        payment_email_finance_accountant_to: [],
        payment_email_finance_manager_to: [],
        receipt_email_finance_to: [],
        receipt_email_finance_cc: [],
        void_receipt_email_finance_cc: [],
        assoc_email_finance_cc: [],
        collection_email_finance_to: []
      },
      // 平台财务管理员列表数据源（收件人/抄送人）：usertype=[5] status=[1,2]
      financeAdminOptions: [],
      // 非法账号确认弹窗
      showInvalidDialog: false,
      invalidList: [],
      // 按邮件业务类型分组，参考设计稿左右布局
      groupList: [{
        title: '付款财务邮件',
        items: [{
          key: 'payment_email_finance_accountant_to',
          label: '待会计审批收件人',
          description_bottom: '邮件发送条件：\n1.付款单处于以下状态时: 待会计审批'
        }, {
          key: 'payment_email_finance_manager_to',
          label: '待财务经理审批收件人',
          description_bottom: '邮件发送条件：\n1.付款单处于以下状态时: 待财务经理审批'
        }]
      }, {
        title: '开票财务邮件',
        items: [{
          key: 'receipt_email_finance_to',
          label: '收件人',
          description_bottom: '邮件发送条件：\n1.开票单处于以下状态时: 待开票、待作废、已开票\n2.预收款开票处于以下状态时: 待抵扣'
        }, {
          key: 'receipt_email_finance_cc',
          label: '抄送人',
          description_bottom: '邮件发送条件：\n1.开票单处于以下状态时: 待开票、待作废、已开票\n2.预收款开票处于以下状态时: 待抵扣'
        }, {
          key: 'void_receipt_email_finance_cc',
          label: '作废/红冲发票抄送人',
          description_bottom: '邮件发送条件：\n1.开票单处于以下状态时: 已作废、已开红冲'
        }]
      }, {
        title: '关联回款邮件',
        items: [{
          key: 'assoc_email_finance_cc',
          label: '抄送人',
          description_bottom: '邮件发送条件：\n1.关联回款\n2.解除回款关联'
        }]
      }, {
        title: '创建回款单邮件',
        items: [{
          key: 'collection_email_finance_to',
          label: '收件人/抄送人',
          description_bottom: '邮件发送规则：\n1. 未指定收件人时，邮件发送至此处配置的邮箱\n2. 已指定收件人时，此处配置的邮箱自动作为抄送人'
        }]
      }]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadUserOptions();

            case 2:
              _this.getCfg();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },

  computed: {
    // 每个收件人/抄送人配置项都必填（多选数组不能为空）
    rules: function rules() {
      var map = {};
      this.groupList.forEach(function (group) {
        group.items.forEach(function (item) {
          map[item.key] = [{ required: true, type: 'array', message: '\u8BF7\u9009\u62E9' + item.label, trigger: 'change' }];
        });
      });
      return map;
    }
  },
  methods: {
    // 拉取平台用户列表，作为 el-select 的数据源
    loadUserOptions: function loadUserOptions() {
      var _this2 = this;

      return request.common('getPlatformUsersIndex', { usertype: [5], status_lists: [1, 2] }).then(function (_ref) {
        var data = _ref.data;

        _this2.financeAdminOptions = Array.isArray(data.data) ? data.data : [];
      }).catch(function () {
        _this2.financeAdminOptions = [];
      });
    },
    onLoad: function onLoad() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) {
          _this3.$message.error('提交内容填写不正确！');
          return;
        }
        var invalid = _this3.checkFinanceAdmins();
        if (!invalid.length) {
          _this3.saveCfg();
          return;
        }
        _this3.invalidList = invalid;
        _this3.showInvalidDialog = true;
      });
    },

    // 校验所选人员是否都在财务管理员列表中（离职/非财务管理员则不在 options 中）
    // 返回 [{ title, label, ids }]，为空表示全部合法
    checkFinanceAdmins: function checkFinanceAdmins() {
      var _this4 = this;

      // 列表未加载成功时无法校验，直接放行
      if (!this.financeAdminOptions.length) return [];
      var validIds = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(this.financeAdminOptions.map(function (o) {
        return o.id;
      }));
      var metaMap = {};
      this.groupList.forEach(function (group) {
        group.items.forEach(function (item) {
          metaMap[item.key] = { title: group.title, label: item.label };
        });
      });
      var invalid = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (key) {
        var ids = _this4.form[key];
        if (!Array.isArray(ids)) return;
        var bad = ids.filter(function (id) {
          return !validIds.has(id);
        });
        if (bad.length) {
          var meta = metaMap[key] || { title: '', label: key };
          invalid.push({ title: meta.title, label: meta.label, ids: bad });
        }
      });
      return invalid;
    },

    // 弹窗中点“继续保存”
    confirmSave: function confirmSave() {
      this.showInvalidDialog = false;
      this.saveCfg();
    },
    saveCfg: function saveCfg() {
      var _this5 = this;

      request.common('saveFinanceEmailNotifyCfg', _.cloneDeep(this.form)).then(function () {
        _this5.$message.success('保存成功');
      });
    },
    getCfg: function getCfg() {
      var _this6 = this;

      request.common('getFinanceEmailNotifyCfg').then(function (_ref2) {
        var data = _ref2.data;

        for (var key in _this6.form) {
          if (Object.prototype.hasOwnProperty.call(data, key) && Array.isArray(data[key])) {
            _this6.form[key] = data[key];
          }
        }
      });
    },
    goBack: function goBack() {
      this.$router.back();
    }
  }
});

/***/ }),

/***/ 4021:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4022);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1a6fc9bd", content, true, {});

/***/ }),

/***/ 4022:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".email-notify-header[data-v-6a6ddcc4]{padding:15px 20px;margin-bottom:20px;border-radius:4px}.email-notify-title[data-v-6a6ddcc4]{font-size:16px;font-weight:500;color:#303133}.email-notify-title i[data-v-6a6ddcc4]{color:#409eff;margin-right:6px}.email-notify-subtitle[data-v-6a6ddcc4]{margin-top:8px;font-size:13px;color:#909399}.email-notify-group[data-v-6a6ddcc4]{position:relative;padding:16px 20px;margin-bottom:16px;border:1px solid #ebeef5;border-radius:4px;background:#fff}.email-notify-group__title[data-v-6a6ddcc4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:-16px -20px 0;padding:12px 20px;font-size:15px;font-weight:600;color:#303133;background:#e5e7edff;border-radius:4px 4px 0 0}.email-notify-group__title .title-dot[data-v-6a6ddcc4]{width:8px;height:8px;margin-right:8px;border-radius:50%;background:#409eff}.email-notify-group__desc[data-v-6a6ddcc4]{font-size:13px;line-height:1.5;color:#909399;white-space:pre-line}.email-notify-group__row[data-v-6a6ddcc4]{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.email-notify-group__row .email-notify-col[data-v-6a6ddcc4]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%;padding:0 12px;-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;z-index:1}.email-notify-group__row .el-form-item[data-v-6a6ddcc4]{margin-bottom:0}.form-actions[data-v-6a6ddcc4]{margin-top:10px}.invalid-tip[data-v-6a6ddcc4]{margin:0 0 8px;font-size:13px;color:#606266}.invalid-table[data-v-6a6ddcc4]{width:100%;border-collapse:collapse;font-size:13px}.invalid-table td[data-v-6a6ddcc4],.invalid-table th[data-v-6a6ddcc4]{padding:6px 10px;border:1px solid #ebeef5;text-align:left}.invalid-table th[data-v-6a6ddcc4]{background:#f5f7fa}", "", {"version":3,"sources":["/workspace/src/views/finance-config/pages/FinanceEmailNotify.vue"],"names":[],"mappings":"AACA,sCAAsC,kBAAkB,mBAAmB,iBAAiB,CAC3F,AACD,qCAAqC,eAAe,gBAAgB,aAAa,CAChF,AACD,uCAAuC,cAAc,gBAAgB,CACpE,AACD,wCAAwC,eAAe,eAAe,aAAa,CAClF,AACD,qCAAqC,kBAAkB,kBAAkB,mBAAmB,yBAAyB,kBAAkB,eAAe,CACrJ,AACD,4CAA4C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,qBAAqB,kBAAkB,eAAe,gBAAgB,cAAc,qBAAqB,yBAAyB,CACpS,AACD,uDAAuD,UAAU,WAAW,iBAAiB,kBAAkB,kBAAkB,CAChI,AACD,2CAA2C,eAAe,gBAAgB,cAAc,oBAAoB,CAC3G,AACD,0CAA0C,kBAAkB,oBAAoB,oBAAoB,aAAa,mBAAmB,cAAc,CACjJ,AACD,4DAA4D,mBAAmB,iBAAiB,aAAa,cAAc,eAAe,8BAA8B,sBAAsB,kBAAkB,SAAS,CACxN,AACD,wDAAwD,eAAe,CACtE,AACD,+BAA+B,eAAe,CAC7C,AACD,8BAA8B,eAAe,eAAe,aAAa,CACxE,AACD,gCAAgC,WAAW,yBAAyB,cAAc,CACjF,AACD,sEAAsE,iBAAiB,yBAAyB,eAAe,CAC9H,AACD,mCAAmC,kBAAkB,CACpD","file":"FinanceEmailNotify.vue","sourcesContent":["\n.email-notify-header[data-v-6a6ddcc4]{padding:15px 20px;margin-bottom:20px;border-radius:4px\n}\n.email-notify-title[data-v-6a6ddcc4]{font-size:16px;font-weight:500;color:#303133\n}\n.email-notify-title i[data-v-6a6ddcc4]{color:#409eff;margin-right:6px\n}\n.email-notify-subtitle[data-v-6a6ddcc4]{margin-top:8px;font-size:13px;color:#909399\n}\n.email-notify-group[data-v-6a6ddcc4]{position:relative;padding:16px 20px;margin-bottom:16px;border:1px solid #ebeef5;border-radius:4px;background:#fff\n}\n.email-notify-group__title[data-v-6a6ddcc4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:-16px -20px 0;padding:12px 20px;font-size:15px;font-weight:600;color:#303133;background:#e5e7edff;border-radius:4px 4px 0 0\n}\n.email-notify-group__title .title-dot[data-v-6a6ddcc4]{width:8px;height:8px;margin-right:8px;border-radius:50%;background:#409eff\n}\n.email-notify-group__desc[data-v-6a6ddcc4]{font-size:13px;line-height:1.5;color:#909399;white-space:pre-line\n}\n.email-notify-group__row[data-v-6a6ddcc4]{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap\n}\n.email-notify-group__row .email-notify-col[data-v-6a6ddcc4]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%;padding:0 12px;-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;z-index:1\n}\n.email-notify-group__row .el-form-item[data-v-6a6ddcc4]{margin-bottom:0\n}\n.form-actions[data-v-6a6ddcc4]{margin-top:10px\n}\n.invalid-tip[data-v-6a6ddcc4]{margin:0 0 8px;font-size:13px;color:#606266\n}\n.invalid-table[data-v-6a6ddcc4]{width:100%;border-collapse:collapse;font-size:13px\n}\n.invalid-table th[data-v-6a6ddcc4],.invalid-table td[data-v-6a6ddcc4]{padding:6px 10px;border:1px solid #ebeef5;text-align:left\n}\n.invalid-table th[data-v-6a6ddcc4]{background:#f5f7fa\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("财务中心设置")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_c('span',{staticClass:"email-notify-header"},[_c('span',{staticClass:"email-notify-title"},[_c('i',{staticClass:"el-icon-info"}),_vm._v(" "),_c('span',[_vm._v("配置财务相关邮件的收件人与抄送人")])])])]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"medium","label-position":"top"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_vm._l((_vm.groupList),function(group){return _c('div',{key:group.title,staticClass:"email-notify-group"},[_c('div',{staticClass:"email-notify-group__title"},[_c('span',{staticClass:"title-dot"}),_vm._v("\n          "+_vm._s(group.title)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"email-notify-group__row"},_vm._l((group.items),function(item,idx){return _c('div',{key:item.key,staticClass:"email-notify-col"},[(item.description_top)?_c('div',{staticClass:"email-notify-group__desc"},[_vm._v("\n              "+_vm._s(item.description_top)+"\n            ")]):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":item.key}},[_c('template',{slot:"label"},[_c('el-tag',{attrs:{"type":idx % 2 === 1 ? 'warning' : '',"size":"small"}},[_vm._v(_vm._s(item.label)+"\n                ")])],1),_vm._v(" "),_c('el-select',{staticClass:"width-max",attrs:{"multiple":"","filterable":"","clearable":"","placeholder":"请输入用户名搜索"},model:{value:(_vm.form[item.key]),callback:function ($$v) {_vm.$set(_vm.form, item.key, $$v)},expression:"form[item.key]"}},_vm._l((_vm.financeAdminOptions),function(opt){return _c('el-option',{key:opt.id,attrs:{"label":opt.mail_address ? ((opt.name) + " / " + (opt.mail_address)) : opt.name,"value":opt.id}})}),1)],2),_vm._v(" "),(item.description_bottom)?_c('div',{staticClass:"email-notify-group__desc"},[_vm._v("\n              "+_vm._s(item.description_bottom)+"\n            ")]):_vm._e()],1)}),0)])}),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("保存\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("返回")])],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"提示","visible":_vm.showInvalidDialog,"width":"50%"},on:{"update:visible":function($event){_vm.showInvalidDialog=$event}}},[_c('p',{staticClass:"invalid-tip"},[_vm._v("以下账号并非财务管理员或已离职，请确认是否继续保存：")]),_vm._v(" "),_c('table',{staticClass:"invalid-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("分组")]),_vm._v(" "),_c('th',[_vm._v("配置项")]),_vm._v(" "),_c('th',[_vm._v("非法账号ID")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.invalidList),function(item,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.ids.join('，')))])])}),0)]),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.confirmSave}},[_vm._v("继续保存")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.showInvalidDialog = false}}},[_vm._v("取消保存")])],1)])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/finance-email-notify.6e96b75c64311ec70cfa.js